export const convertMaterialColumnsToMaterialReactTable = (_col) => {
  try {
    let _final_col = [];
    for (let _val of _col) {
      _final_col.push({
        ..._val,
        accessorKey: _val.field,
        header: _val.title,
      });
    }
    return _final_col;
  } catch (error) {
    return [];
  }
};
